<template>
  <section class="faq-accordion w-full bg-white px-4 py-12 md:py-16">
    <div class="mx-auto flex w-full max-w-[1200px] flex-col items-center gap-12">
      <div class="flex flex-col items-center gap-1 text-center">
        <p
          v-if="overlineText"
          class="text-[14px] font-semibold uppercase leading-5 tracking-[1px]"
        >
          {{ overlineText }}
        </p>
        <h2
          class="text-[36px] font-medium leading-[44px] tracking-[-0.72px]"
        >
          {{ headingText }}
        </h2>
      </div>

      <div class="flex w-full flex-col gap-3 max-w-[790px]">
        <details
          v-for="(item, idx) in items"
          :key="idx"
          class="group rounded-lg border border-[#e5e7eb] bg-white p-4 transition-colors open:border-gray-300"
        >
          <summary
            class="flex cursor-pointer list-none items-center justify-between gap-3 text-[16px] font-medium leading-6 text-dark"
          >
            <span>{{ item.question }}</span>
            <svg
              class="h-5 w-5 shrink-0 text-gray transition-transform group-open:rotate-180"
              viewBox="0 0 20 20"
              fill="none"
              aria-hidden="true"
            >
              <path d="M5 7.5 10 12.5 15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </summary>
          <div
            v-if="item.answer"
            class="mt-4 border-t border-gray-100 pt-4 text-[15px] leading-7 text-gray-700"
          >
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="prose prose-sm max-w-none" v-html="item.answer" />
          </div>
        </details>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  overlineText: { type: String, default: '' },
  headingText:  { type: String, default: 'FAQ - Najczęściej zadawane pytania' },
  q1: { type: String, default: '' }, a1: { type: String, default: '' },
  q2: { type: String, default: '' }, a2: { type: String, default: '' },
  q3: { type: String, default: '' }, a3: { type: String, default: '' },
  q4: { type: String, default: '' }, a4: { type: String, default: '' },
  q5: { type: String, default: '' }, a5: { type: String, default: '' },
  q6: { type: String, default: '' }, a6: { type: String, default: '' },
  q7: { type: String, default: '' }, a7: { type: String, default: '' },
  q8: { type: String, default: '' }, a8: { type: String, default: '' },
  // eslint-disable-next-line vue/prop-name-casing
  site_context: { type: String, default: null },
});

const items = computed(() => {
  const out = [];
  for (let i = 1; i <= 8; i += 1) {
    const question = props[`q${i}`];
    if (!question) continue;
    out.push({ question, answer: props[`a${i}`] });
  }
  return out;
});
</script>
